import { getCndnReasonName } from '@/helpers/cndnHelper';
import { ICndnFreeForm, ICndnFreeFormItem } from '@/interfaces/cndnFreeForm';
import { convertNumberToThaiText, formatNumber } from '@/utils/dataUtils';
import { round } from 'lodash';
import React from 'react';

interface IProps {
  items?: Partial<ICndnFreeFormItem>[];
  data: ICndnFreeForm;
  showFooter: boolean;
}

const TemplateCndnFreeformInfoItem = ({ data, items, showFooter }: IProps) => {
  return (
    <>
      <div className="flex w-full text-xs mt-2">
        <table
          border={1}
          cellSpacing={0}
          cellPadding={5}
          style={{
            width: '100%',
            border: '0.5px; black solid',
            borderCollapse: 'collapse',
          }}
        >
          <tr>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={5}
            >
              <strong>
                ลำดับ <br /> Line No.
              </strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={100}
            >
              <strong>
                รหัสสินค้า <br /> Item Code
              </strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
            >
              <strong>
                รายการสินค้า <br /> Item Description
              </strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
            >
              <strong>
                เลขที่ผลิต <br /> Lot no.
              </strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
            >
              <strong>
                จำนวน <br /> Quantity
              </strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
            >
              <strong>
                หน่วย <br />
                Unit
              </strong>
            </td>
            <>
              <td
                style={{
                  border: '1px solid black',
                  textAlign: 'center',
                  verticalAlign: 'middle',
                }}
                width={81}
              >
                <strong>
                  ราคาต่อหน่วย <br />
                  Unit Price
                </strong>
              </td>
              <td
                style={{
                  border: '1px solid black',
                  textAlign: 'center',
                  verticalAlign: 'middle',
                }}
                width={115}
              >
                <strong>
                  ราคาขายไม่รวม VAT <br />
                  Price Exclude VAT
                </strong>
              </td>
              <td
                style={{
                  border: '1px solid black',
                  textAlign: 'center',
                  verticalAlign: 'middle',
                }}
                width={20}
              >
                <strong>
                  VAT <br />
                  (%)
                </strong>
              </td>
              <td
                style={{
                  border: '1px solid black',
                  textAlign: 'center',
                  verticalAlign: 'middle',
                }}
                width={30}
              >
                <strong>
                  จำนวนเงิน (บาท) <br />
                  Amount(Baht)
                </strong>
              </td>
            </>
          </tr>
          {items
            ?.filter(c => Number(c.unitPrice) > 0)
            .map((i, idx) => {
              const vatRate = round(
                Number(i.totalPrice) * (data.taxRate / 100),
                2,
              );
              return (
                <tr key={i.id}>
                  <td
                    style={{
                      border: '1px solid black',
                      textAlign: 'center',
                    }}
                  >
                    {idx + 1}
                  </td>
                  <td
                    style={{
                      border: '1px solid black',
                      textAlign: 'center',
                    }}
                  >
                    {i.productCode}
                  </td>
                  <td
                    style={{
                      border: '1px solid black',
                    }}
                  >
                    {i.productName}
                  </td>
                  <td
                    style={{
                      border: '1px solid black',
                      textAlign: 'center',
                    }}
                  >
                    {i.lotNumber}
                  </td>
                  <td
                    style={{
                      border: '1px solid black',
                      textAlign: 'center',
                    }}
                  >
                    {formatNumber(
                      showFooter ? Number(i.orderQuantity) : Number(i.quantity),
                      2,
                    )}
                  </td>
                  <td
                    style={{
                      border: '1px solid black',
                      textAlign: 'center',
                    }}
                  >
                    {i.baseUnitId}
                  </td>
                  <td
                    style={{
                      border: '1px solid black',
                      textAlign: 'center',
                    }}
                  >
                    {formatNumber(Number(i.unitPrice), 2)}
                  </td>
                  <td
                    style={{
                      border: '1px solid black',
                      textAlign: 'right',
                    }}
                  >
                    {formatNumber(Number(i.totalAmount || 0), 2)}
                  </td>
                  <td
                    style={{
                      border: '1px solid black',
                      textAlign: 'right',
                    }}
                  >
                    {(data.taxRate && `${data.taxRate || 0}%`) || '-'}
                  </td>

                  <td
                    style={{
                      border: '1px solid black',
                      textAlign: 'right',
                    }}
                  >
                    {formatNumber(
                      Number(i.totalAmount || 0) + (+vatRate || 0),
                      2,
                    )}
                  </td>
                </tr>
              );
            })}
          {/* <tr>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'right',
                height: 25,
              }}
              colSpan={10}
            ></td>
          </tr> */}
          {showFooter && (
            <>
              <tr>
                <td
                  style={{
                    textAlign: 'right',
                  }}
                  colSpan={6}
                >
                  <div className="flex flex-row justify-between">
                    <strong>
                      สาเหตุ : {data.remark || getCndnReasonName(data.reason)}
                    </strong>
                    <strong>มูลค่าตามใบแจ้งหนี้เดิม</strong>
                  </div>
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'right',
                  }}
                  colSpan={4}
                >
                  <strong>
                    {' '}
                    {formatNumber(Number(data?.invoiceAmount), 2)}
                  </strong>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    textAlign: 'right',
                  }}
                  colSpan={6}
                >
                  <strong>มูลค่าที่ถูกต้อง</strong>
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'right',
                  }}
                  colSpan={4}
                >
                  <strong>
                    {' '}
                    {formatNumber(Number(data?.newInvoiceAmount), 2)}
                  </strong>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    textAlign: 'right',
                  }}
                  colSpan={6}
                >
                  <strong>ผลต่าง</strong>
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'right',
                  }}
                  colSpan={4}
                >
                  <strong> {formatNumber(Number(data?.totalAmount), 2)}</strong>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    textAlign: 'right',
                  }}
                  colSpan={6}
                >
                  <strong>ส่วนลด (บาท)</strong>
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'right',
                  }}
                  colSpan={4}
                >
                  <strong>
                    {' '}
                    {formatNumber(Number(data?.discountAmount), 2)}
                  </strong>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    textAlign: 'right',
                  }}
                  colSpan={6}
                >
                  <strong>ยอดรวมหลังหักส่วนลด</strong>
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'right',
                  }}
                  colSpan={4}
                >
                  <strong>
                    {formatNumber(Number(data?.totalAfterDiscountAmount), 2)}
                  </strong>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    textAlign: 'right',
                  }}
                  colSpan={6}
                >
                  <strong>
                    ภาษีมูลค่าเพิ่ม{' '}
                    {(data.taxRate && `${data.taxRate || 0} %`) || ''}
                  </strong>
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'right',
                  }}
                  colSpan={4}
                >
                  <strong> {formatNumber(Number(data?.vatAmount), 2)}</strong>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    textAlign: 'right',
                  }}
                  colSpan={6}
                >
                  <strong>จำนวนเงินทั้งสิ้น</strong>
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'right',
                  }}
                  colSpan={4}
                >
                  <strong>
                    {formatNumber(Number(data?.grandTotalAmount), 2)}
                  </strong>
                </td>
              </tr>
              <tr>
                <td colSpan={6}></td>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'right',
                  }}
                  colSpan={4}
                >
                  <strong>
                    {convertNumberToThaiText(Number(data?.grandTotalAmount))}
                  </strong>
                </td>
              </tr>
            </>
          )}
        </table>
      </div>
    </>
  );
};

export default TemplateCndnFreeformInfoItem;
